export default __webpack_public_path__ + "static/media/check-di-empty.961110d8.svg";